<template>
  <div class="impressum-page">
    <!-- Navigation -->
    <nav class="nav-bar">
      <div class="nav-container">
        <div class="logo-section">
          <svg class="logo-svg" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#667eea; stop-opacity:1" />
                <stop offset="100%" style="stop-color:#764ba2; stop-opacity:1" />
              </linearGradient>
            </defs>
            <path d="M 15 10 L 25 10 L 35 25 L 25 40 L 15 40 L 25 25 Z" fill="url(#logoGradient)"/>
            <circle cx="40" cy="15" r="3" fill="url(#logoGradient)"/>
            <circle cx="40" cy="35" r="3" fill="url(#logoGradient)"/>
          </svg>
          <div class="logo-text">
            <span class="logo-name">Nick Volkmann</span>
            <span class="logo-subtitle">IT-Beratung</span>
          </div>
        </div>
        <a href="/" class="back-link">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
          Zurück zur Startseite
        </a>
      </div>
    </nav>

    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-background">
        <div class="hero-grid"></div>
      </div>
      <div class="hero-content">
        <div class="hero-badge">Rechtliche Informationen</div>
        <h1 class="hero-title">Impressum</h1>
        <p class="hero-subtitle">Angaben gemäß § 5 TMG</p>
      </div>
    </section>

    <!-- Content Section -->
    <section class="content-section">
      <div class="content-container">
        <div class="content-card">
          
          <!-- Anbieter -->
          <div class="section-block">
            <h2 class="section-title">
              <div class="icon-box">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </div>
              Anbieter
            </h2>
            <div class="section-content">
              <p class="company-name">Nick Volkmann - IT-Beratung</p>
              <p>Inhaber: Nick Volkmann</p>
            </div>
          </div>

          <!-- Kontakt -->
          <div class="section-block">
            <h2 class="section-title">
              <div class="icon-box">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                  <rect x="2" y="4" width="20" height="16" rx="2"/>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                </svg>
              </div>
              Kontakt
            </h2>
            <div class="section-content">
              <div class="contact-item">
                <svg class="contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                <div>
                  <p class="contact-label">Anschrift</p>
                  <p class="contact-value">Leipziger Straße 27b</p>
                  <p class="contact-value">01097 Dresden</p>
                </div>
              </div>
              <div class="contact-item">
                <svg class="contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="2" y="4" width="20" height="16" rx="2"/>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                </svg>
                <div>
                  <p class="contact-label">E-Mail</p>
                  <a href="mailto:info@nick-volkmann.de" class="email-link">
                    info@nick-volkmann.de
                  </a>
                </div>
              </div>
              <div class="contact-item">
                <svg class="contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <div>
                  <p class="contact-label">Telefon</p>
                  <p class="contact-value">0176/20074278</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Umsatzsteuer-ID -->
          <div class="section-block">
            <h2 class="section-title">
              <div class="icon-box">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/>
                  <line x1="16" y1="17" x2="8" y2="17"/>
                </svg>
              </div>
              Umsatzsteuer-ID
            </h2>
            <div class="section-content">
              <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</p>
              <p class="highlight-text">DE453855990</p>
            </div>
          </div>

          <!-- Verantwortlich -->
          <div class="section-block">
            <h2 class="section-title">
              <div class="icon-box">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <line x1="19" y1="8" x2="19" y2="14"/>
                  <line x1="22" y1="11" x2="16" y2="11"/>
                </svg>
              </div>
              Verantwortlich für den Inhalt
            </h2>
            <div class="section-content">
              <p>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</p>
              <p class="highlight-text">Nick Volkmann</p>
              <p class="highlight-text">Leipziger Straße 27b</p>
              <p class="highlight-text">01097 Dresden</p>
            </div>
          </div>

          <!-- EU-Streitschlichtung -->
          <div class="section-block">
            <h2 class="section-title">
              <div class="icon-box">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 6v6l4 2"/>
                </svg>
              </div>
              EU-Streitschlichtung
            </h2>
            <div class="section-content">
              <p class="mb-small">Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:</p>
              <a 
                href="https://ec.europa.eu/consumers/odr" 
                target="_blank" 
                rel="noopener noreferrer"
                class="external-link"
              >
                https://ec.europa.eu/consumers/odr
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                  <polyline points="15 3 21 3 21 9"/>
                  <line x1="10" y1="14" x2="21" y2="3"/>
                </svg>
              </a>
            </div>
          </div>

          <!-- Verbraucherstreitbeilegung -->
          <div class="section-block">
            <h2 class="section-title">
              <div class="icon-box">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              Verbraucherstreitbeilegung
            </h2>
            <div class="section-content">
              <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
            </div>
          </div>

          <!-- Haftungsausschluss -->
          <div class="section-block">
            <h2 class="section-title">
              <div class="icon-box">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
              </div>
              Haftungsausschluss
            </h2>
            <div class="section-content disclaimer-content">
              <div class="disclaimer-block">
                <h3 class="disclaimer-title">Haftung für Inhalte</h3>
                <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
              </div>
              <div class="disclaimer-block">
                <h3 class="disclaimer-title">Haftung für Links</h3>
                <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</p>
              </div>
              <div class="disclaimer-block">
                <h3 class="disclaimer-title">Urheberrecht</h3>
                <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
              </div>
            </div>
          </div>

          <!-- Footer Note -->
          <div class="footer-note">
            <p>© 2025 Nick Volkmann - IT-Beratung. Alle Rechte vorbehalten.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Back to Top Button -->
    <button
      @click="scrollToTop"
      class="back-to-top"
      aria-label="Nach oben scrollen"
    >
      <svg 
        width="20" 
        height="20" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2"
      >
        <path d="M12 19V5M5 12l7-7 7 7"/>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Impressum',
  methods: {
    scrollTo(section) {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.impressum-page {
  min-height: 100vh;
  background-color: #ffffff;
}

/* Navigation */
.nav-bar {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  z-index: 50;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.nav-container {
  max-width: 1152px;
  margin: 0 auto;
  padding: 1.25rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.logo-svg {
  width: 2.5rem;
  height: 2.5rem;
}

.logo-text {
  display: flex;
  flex-direction: column;
}

.logo-name {
  font-size: 1.125rem;
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
}

.logo-subtitle {
  font-size: 0.75rem;
  color: #4b5563;
  font-weight: 500;
}

.back-link {
  color: #374151;
  font-weight: 500;
  font-size: 0.875rem;
  text-decoration: none;
  transition: color 0.3s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.back-link:hover {
  color: #7c3aed;
}

/* Hero Section */
.hero-section {
  position: relative;
  padding-top: 8rem;
  padding-bottom: 5rem;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom right, #7c3aed, #581c87);
  z-index: 0;
}

.hero-grid {
  position: absolute;
  inset: 0;
  opacity: 0.1;
  background-image: 
    linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px);
  background-size: 50px 50px;
}

.hero-content {
  max-width: 1152px;
  margin: 0 auto;
  padding: 0 1.5rem;
  position: relative;
  z-index: 10;
}

.hero-badge {
  display: inline-block;
  background-color: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(4px);
  color: white;
  padding: 0.5rem 1.25rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 1.5rem;
}

.hero-title {
  font-size: 3rem;
  font-weight: 800;
  color: white;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.9);
  max-width: 42rem;
  line-height: 1.6;
}

@media (min-width: 768px) {
  .hero-title {
    font-size: 3.75rem;
  }
}

/* Content Section */
.content-section {
  padding: 5rem 0;
  background-color: #f9fafb;
}

.content-container {
  max-width: 56rem;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.content-card {
  background-color: white;
  border-radius: 1.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  padding: 2rem;
}

@media (min-width: 768px) {
  .content-card {
    padding: 3rem;
  }
}

.section-block {
  margin-bottom: 3rem;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.icon-box {
  width: 3rem;
  height: 3rem;
  background: linear-gradient(to bottom right, #7c3aed, #6b21a8);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.section-content {
  margin-left: 3.75rem;
  color: #374151;
  line-height: 1.6;
}

.section-content p {
  margin-bottom: 0.75rem;
}

.company-name {
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827 !important;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.contact-icon {
  width: 1.25rem;
  height: 1.25rem;
  color: #7c3aed;
  margin-top: 0.25rem;
  flex-shrink: 0;
}

.contact-label {
  font-weight: 500;
  color: #111827;
  margin-bottom: 0.25rem;
}

.contact-value {
  color: #374151;
}

.email-link {
  color: #7c3aed;
  text-decoration: none;
  transition: color 0.3s;
}

.email-link:hover {
  color: #6b21a8;
}

.highlight-text {
  font-weight: 500;
  margin-top: 0.5rem;
}

.mb-small {
  margin-bottom: 0.75rem;
}

.external-link {
  color: #7c3aed;
  font-weight: 500;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: color 0.3s;
}

.external-link:hover {
  color: #6b21a8;
}

.disclaimer-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.disclaimer-block p {
  margin-bottom: 0;
}

.disclaimer-title {
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.5rem;
}

.footer-note {
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb;
}

.footer-note p {
  font-size: 0.875rem;
  color: #6b7280;
  text-align: center;
  margin: 0;
}

/* Back to Top Button */
.back-to-top {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  background: linear-gradient(to bottom right, #7c3aed, #6b21a8);
  color: white;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  border: none;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
}

.back-to-top:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  transform: scale(1.1);
}

.back-to-top svg {
  transition: transform 0.3s;
}

.back-to-top:hover svg {
  transform: translateY(-0.25rem);
}
</style>